const RoleLevels = {
  BU_MANAGERS: 1,
  DEPARTMENT_MANAGERS: 2,
  PORTFOLIO_MANAGERS: 3,
  PRODUCT_MANAGERS: 4
}

export default RoleLevels
